import React, { ChangeEvent, useEffect, useState } from 'react';
import { TUIBuilder } from '../ui';
import { XIcon } from 'assests/GmsIcons';

type EditPageProps = {
    editPage: any;
    pageName?: string;
    setPageEditFlag: (flag: boolean) => void;
    onDelete: (itemIndex: number) => void;
    activeIndex: number;
    setActiveIndex?: (index: number) => void;
    pageCount?: number;
    handleAddButtonClick?: () => void;
    setUiModelProjectData: React.Dispatch<React.SetStateAction<TUIBuilder>>;
}

const EditPage = ({editPage, pageName, setPageEditFlag, onDelete, activeIndex, setActiveIndex, pageCount, setUiModelProjectData}: EditPageProps) => {
    const [uiPage, setUiPage] = useState<any>();
    const [isAutoAdvancement, setIsAutoAdvancement] = useState<boolean>(false)
    const pageLayoutLabels = ["Guided Selling", "Default"]

    const handleAutoAdvancementChange = () => {
        setIsAutoAdvancement(!isAutoAdvancement)
        setUiPage((prevUiPage: any) => {
            return { ...prevUiPage, isAutoAdvancement: !isAutoAdvancement };
        })   
    }

    const handlePageLayoutChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const layoutValue = event.target.value;
        setUiPage((prevUiPage: any) => ({
            ...prevUiPage,
            pageLayout: layoutValue,
        }));
    }

    useEffect (() => {
        setUiPage(editPage);
        if(editPage){
            setIsAutoAdvancement(editPage?.isAutoAdvancement)
        }
    }, [editPage]);

    const handleChange = (value: string) => {
        setUiPage((prevUiPage: any) => {
            return { ...prevUiPage, value: value };
        })
    }

    const handleChangePageLabel = (value: string) => {
        setUiPage((prevUiPage: any) => {
            return { ...prevUiPage, pageLabel: value };
        })
    }

    const savePage = () => {
        setUiModelProjectData((prevUiModel: any) => {
            const updatedUiModel = { ...prevUiModel };
            updatedUiModel.pages[activeIndex].pageName = uiPage.value;
            updatedUiModel.pages[activeIndex].pageLabel = uiPage.pageLabel;
            updatedUiModel.pages[activeIndex].isAutoAdvancement = isAutoAdvancement;
            updatedUiModel.pages[activeIndex].pageLayout = uiPage.pageLayout;
            return updatedUiModel;
        });
    }

    return(
        <div className="tw-w-[375px] tw-absolute tw-h-[95vh] tw-bg-white tw-shadow tw-float-right tw-right-0 tw-top-0" style={{zIndex: 1000}}>
            <div className="tw-text-sky-950 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-leading-tight tw-my-[18px] tw-mx-[12px]">{'Page'}</div>
            <button className="tw-text-black tw-float-right tw-my-[-36px] tw-mx-[24px]" onClick={()=>setPageEditFlag(false)}>
                <XIcon />
            </button>
            <div className="tw-w-[373px] tw-h-[0px] tw-border tw-border-zinc-300"/>
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Title</div>
            <input className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-[335px] tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none tw-mx-[12px]" 
                type='text'
                value={uiPage?.value}
                onChange={(e) => {
                    handleChange(e.target.value)
                }}
                placeholder={'Page n'} 
            />
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[8px] tw-mb-2 tw-mx-[12px]">Page Label</div>
            <input className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-[335px] tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none tw-mx-[12px]"
                type='text'
                value={uiPage?.pageLabel}
                onChange={(e) => {
                    handleChangePageLabel(e.target.value)
                }}
                placeholder={'Page Label'}
            />
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[24px] tw-mb-3 tw-mx-[12px]">Configuration</div>
            <div className="tw-flex tw-mx-4"/>

            <div className="tw-mx-[12px]">
                <div className="tw-text-blue-950 tw-text-sm  tw-leading-tight">Auto-advances</div>
                <label className='tw-autoSaverSwitch tw-relative tw-inline-flex tw-cursor-pointer tw-select-none tw-items-center'>
                    <input
                        type='checkbox'
                        name='autoSaver'
                        className='tw-sr-only'
                        checked={isAutoAdvancement}
                        onChange={handleAutoAdvancementChange}
                    />
                    <span
                    className={`tw-slider tw-mr-3 tw-flex tw-h-[26px] tw-w-[50px] tw-items-center tw-rounded-full tw-p-1 tw-duration-200 tw-my-[12px] ${
                        isAutoAdvancement ? 'tw-bg-[#488328]' : 'tw-bg-[#C9CCCF]'
                    }`}
                    >
                    <span
                        className={`tw-dot tw-h-[18px] tw-w-[18px] tw-rounded-full tw-bg-white tw-duration-200 ${
                        isAutoAdvancement ? 'tw-translate-x-6' : ''
                        }`}
                    ></span>
                    </span>
                    {/* <span className='tw-label tw-flex tw-items-center tw-text-sm tw-font-medium tw-text-black'>
                    Auto Saver
                    </span> */}
                </label>
            </div>

            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[8px] tw-mx-[12px] tw-mb-2">Layout</div>
            <select className="form-select drop-down-dm tw-ps-3 tw-ms-3 tw-w-[90%] shadow-none" value={uiPage?.pageLayout ?? 'Default'} onChange={handlePageLayoutChange} >
                {pageLayoutLabels && pageLayoutLabels.map((item, index) => {
                    return (
                        <option value={item} key={item + index}>
                        {item}
                    </option>);
                })}
            </select>

            <div className="tw-text-orange-700 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-cursor-pointer tw-mx-[12px]"
                onClick={()=>{
                    if(activeIndex >= 0) {
                        onDelete(activeIndex)
                        setPageEditFlag(false)
                    }
                }
            }>Delete Page</div>
            <button onClick={() => {
                savePage();
                setPageEditFlag(false);
            }} className="small-filled-btn tw-px-[24px] tw-h-[30px] tw-mx-[12px] tw-mt-[18px]">Done
            </button>
        </div>
    );
}

export default EditPage;
